"use client";

import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  Button,
  Select,
  Input,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalFooter,
  useDisclosure,
  FormControl,
  FormLabel,
  IconButton,
  Text,
} from "@chakra-ui/react";
import { EditIcon, DeleteIcon } from "@chakra-ui/icons";
import {
  fetchEmployerDataAsync,
  selectEmployerData,
} from "../../EmployerData/EmployerDataSlice";
import {
  addSubscriptionTopUpAsync,
  fetchSubscriptionTopUpAsync,
  updateSubscriptionTopUpAsync,
  deleteSubscriptionTopUpAsync,
  selectSubscriptionTopUp,
} from "../../Subscriptions/SubscriptionTopUp/SubscriptionTopUpSlice";

const initialSubscriptionState = {
  // id: "",
  user_uuid: "",
  type: "job_post",
  value: "",
};

export default function SubscriptionTopUp() {
  const {
    isOpen: isAddOpen,
    onOpen: onAddOpen,
    onClose: onAddClose,
  } = useDisclosure();
  const {
    isOpen: isEditOpen,
    onOpen: onEditOpen,
    onClose: onEditClose,
  } = useDisclosure();
  
  const [newSubscription, setNewSubscription] = useState(
    initialSubscriptionState
  );
  const [editingSubscription, setEditingSubscription] = useState(
    initialSubscriptionState
  );
  const users = useSelector(selectEmployerData);
  const subscriptions = useSelector(selectSubscriptionTopUp);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(fetchSubscriptionTopUpAsync());
    dispatch(fetchEmployerDataAsync());
  }, [dispatch]);

  const handleAddSubscription = async () => {
    try {
      await dispatch(addSubscriptionTopUpAsync(newSubscription));
      resetAndCloseAddModal();
      dispatch(fetchSubscriptionTopUpAsync());
    } catch (error) {
      console.error("Error adding subscription:", error);
    }
  };

  const handleUpdateSubscription = async () => {
    try {
      // console.log("data", editingSubscription);
      const updateSubscriptiondata = {
        type: editingSubscription.type,
        value: editingSubscription.value,
      };

      await dispatch(
        updateSubscriptionTopUpAsync({
          id: editingSubscription.uuid,
          updateSubscriptiondata,
        })
      );
      resetAndCloseEditModal();
      dispatch(fetchSubscriptionTopUpAsync());
    } catch (error) {
      console.error("Error updating subscription:", error);
    }
  };

  const handleDeleteSubscription = async (id) => {
    if (window.confirm("Are you sure you want to delete this subscription?")) {
      try {
        await dispatch(deleteSubscriptionTopUpAsync(id));
        dispatch(fetchSubscriptionTopUpAsync());
      } catch (error) {
        console.error("Error deleting subscription:", error);
      }
    }
  };

  const openEditModal = (subscription) => {
    setEditingSubscription(subscription);
    onEditOpen();
  };

  const resetAndCloseAddModal = () => {
    setNewSubscription(initialSubscriptionState);
    onAddClose();
  };

  const resetAndCloseEditModal = () => {
    setEditingSubscription(initialSubscriptionState);
    onEditClose();
  };

  const planTypes = [
    "job_post",
    "urgent_hiring_tag",
    "candidate_unlock",
    "job_published",
    "notification_via_email_sms_whatsapp",
    "job_boosts",
    "smart_boost_via_email_sms_whatsapp",
    "dedicated_relationship_manager",
    "campion_via_email_sms_whatsapp",
    "multiple_user_login",
    "reports",
    "company_branding",
  ];

  return (
    <div>
      <Button onClick={onAddOpen}>Add New Subscription</Button>

      <Modal isOpen={isAddOpen} onClose={resetAndCloseAddModal}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Add New Subscription</ModalHeader>
          <ModalBody>
            <FormControl>
              <FormLabel>User</FormLabel>
              <Select
                value={newSubscription.user_uuid}
                onChange={(e) => 
                  setNewSubscription({
                    ...newSubscription,
                    user_uuid: e.target.value,
                  })
                }
              >
                <option value="">Select a user</option>
                {users.map((user) => (
                  <option key={user.uuid} value={user.uuid}>
                    {user.name}
                  </option> 
                ))}
              </Select>
            </FormControl>
            <FormControl mt={4}>
              <FormLabel>Type</FormLabel>
              <Select
                value={newSubscription.type}
                onChange={(e) =>
                  setNewSubscription({
                    ...newSubscription,
                    type: e.target.value,
                  })
                }
              >
                {planTypes.map((type) => (
                  <option key={type} value={type}>
                    {type}
                  </option>
                ))}
              </Select>
            </FormControl>
            <FormControl mt={4}>
              <FormLabel>Value</FormLabel>
              <Input
                value={newSubscription.value}
                onChange={(e) =>
                  setNewSubscription({
                    ...newSubscription,
                    value: e.target.value,
                  })
                }
              />
            </FormControl>
          </ModalBody>
          <ModalFooter>
            <Button colorScheme="blue" mr={3} onClick={handleAddSubscription}>
              Add Subscription
            </Button>
            <Button variant="ghost" onClick={resetAndCloseAddModal}>
              Cancel
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>

      <Modal isOpen={isEditOpen} onClose={resetAndCloseEditModal}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Edit Subscription</ModalHeader>
          <ModalBody>
            <FormControl>
              <FormLabel>User</FormLabel>
              {editingSubscription?.employer ? (
                <Text>{editingSubscription?.employer?.name}</Text>
              ) : (
                <Select
                  value={editingSubscription.user_uuid}
                  onChange={(e) =>
                    setEditingSubscription({
                      ...editingSubscription,
                      user_uuid: e.target.value,
                    })
                  }
                >
                  {users.map((user) => (
                    <option key={user.uuid} value={user.uuid}>
                      {user.name}
                    </option>
                  ))}
                </Select>
              )}
            </FormControl>

            <FormControl mt={4}>
              <FormLabel>Type</FormLabel>
              <Select
                value={editingSubscription.type}
                onChange={(e) =>
                  setEditingSubscription({
                    ...editingSubscription,
                    type: e.target.value,
                  })
                }
              >
                {planTypes.map((type) => (
                  <option key={type} value={type}>
                    {type}
                  </option>
                ))}
              </Select>
            </FormControl>
            <FormControl mt={4}>
              <FormLabel>Value</FormLabel>
              <Input
                value={editingSubscription.value}
                onChange={(e) =>
                  setEditingSubscription({
                    ...editingSubscription,
                    value: e.target.value,
                  })
                }
              />
            </FormControl>
          </ModalBody>
          <ModalFooter>
            <Button
              colorScheme="blue"
              mr={3}
              onClick={handleUpdateSubscription}
            >
              Update Subscription
            </Button>
            <Button variant="ghost" onClick={resetAndCloseEditModal}>
              Cancel
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>

      <Table mt={6} variant="simple">
        <Thead>
          <Tr>
            <Th>User</Th>
            <Th>Type</Th>
            <Th>Value</Th>
            <Th>Actions</Th>
          </Tr>
        </Thead>
        <Tbody>
          {subscriptions.map((subscription) => (
            <Tr key={subscription.id}>
              <Td className="capitalize">{subscription.employer?.name}</Td>
              <Td>{subscription.type}</Td>
              <Td>{subscription.value}</Td>
              <Td>
                <IconButton
                  aria-label="Edit subscription"
                  icon={<EditIcon />}
                  onClick={() => openEditModal(subscription)}
                  mr={2}
                />
                <IconButton
                  aria-label="Delete subscription"
                  icon={<DeleteIcon />}
                  onClick={() => handleDeleteSubscription(subscription.uuid)}
                />
              </Td>
            </Tr>
          ))}
        </Tbody>
      </Table>
    </div>
  );
}
